'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _browser = require('@beastshop/browser');

var _browser2 = _interopRequireDefault(_browser);

var _simpleSemver = require('simple-semver');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = _browser2.default.app();
var version = app ? app.version : '0.0.0';
var NEW_BRIDGE_VISION = app ? (0, _simpleSemver.gte)(app.version, '2.5.0') : false;

exports.default = _browser2.default.app() ? _browser2.default.ios() ? ios_factory : _browser2.default.uniapp() ? uni_factory : android_factory : function () {
  if (_browser2.default.uniapp()) {
    return uni_factory();
  }
  return new BridgeBase();
};

var BridgeBase = function () {
  function BridgeBase() {
    (0, _classCallCheck3.default)(this, BridgeBase);

    this.callbacks = [];
    this.bridge_ready = false;
    this._setup();
  }

  // do nothing


  (0, _createClass3.default)(BridgeBase, [{
    key: '_setup',
    value: function _setup() {}
  }, {
    key: '_set_bridge',
    value: function _set_bridge(bridge) {
      this.bridge = bridge;
      this.invoke = this._invoke;
      this.handler = this._handler;

      var callbacks = this.callbacks;
      delete this.callbacks;
      this.bridge_ready = true;

      callbacks.forEach(function (fn) {
        fn();
      });
      callbacks.length = 0;
    }
  }, {
    key: '_ready',
    value: function _ready(callback) {
      if (this.bridge_ready) {
        return callback(this.bridge);
      }

      this.callbacks.push(callback);
    }

    // do nothing

  }, {
    key: 'setInvoker',
    value: function setInvoker() {}
  }, {
    key: 'invoke',
    value: function invoke(handler_name, data) {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        // if the bridge is not ready, `base._invoke` is not ready either.
        _this._ready(function () {
          _this._invoke(handler_name, data).then(resolve);
        });
      });
    }
  }, {
    key: '_invoke',
    value: function _invoke(handler_name, data) {
      var _this2 = this;

      return new _promise2.default(function (resolve) {
        _this2.bridge.callHandler(handler_name, data, _this2._proxy(resolve));
      });
    }
  }, {
    key: 'handler',
    value: function handler(name, callback) {
      var _this3 = this;

      this._ready(function () {
        _this3._handler(name, callback);
      });
    }
  }, {
    key: '_handler',
    value: function _handler(name, callback) {
      this.bridge.registerHandler(name, this._proxy(callback));
    }
  }, {
    key: '_proxy',
    value: function _proxy(callback) {
      return callback;
    }
  }]);
  return BridgeBase;
}();

function ios_factory() {
  var Bridge = function (_BridgeBase) {
    (0, _inherits3.default)(Bridge, _BridgeBase);

    function Bridge() {
      (0, _classCallCheck3.default)(this, Bridge);
      return (0, _possibleConstructorReturn3.default)(this, (Bridge.__proto__ || (0, _getPrototypeOf2.default)(Bridge)).call(this));
    }

    (0, _createClass3.default)(Bridge, [{
      key: '_setup',
      value: function _setup() {
        var _this5 = this;

        var bridge_ready_callbacks = window.WVJBCallbacks || (window.WVJBCallbacks = []);
        if (NEW_BRIDGE_VISION) {
          window.webkit.messageHandlers.Bridge.postMessage((0, _stringify2.default)({
            handlerName: 'bridgeLoaded'
          }));
        } else {
          var iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = (0, _simpleSemver.gte)(version, '1.3.0') ? 'https://__bridge_loaded__' : 'wvjbscheme://__BRIDGE_LOADED__';
          document.documentElement.appendChild(iframe);
          setTimeout(function () {
            document.documentElement.removeChild(iframe);
          });
        }

        bridge_ready_callbacks.push(function (bridge) {
          _this5._set_bridge(bridge);
        });
      }
    }]);
    return Bridge;
  }(BridgeBase);

  return new Bridge();
}

function android_factory() {
  var Bridge = function (_BridgeBase2) {
    (0, _inherits3.default)(Bridge, _BridgeBase2);

    function Bridge() {
      (0, _classCallCheck3.default)(this, Bridge);
      return (0, _possibleConstructorReturn3.default)(this, (Bridge.__proto__ || (0, _getPrototypeOf2.default)(Bridge)).call(this));
    }

    (0, _createClass3.default)(Bridge, [{
      key: '_android_ready',
      value: function _android_ready() {
        var bridge = window.WebViewJavascriptBridge;
        this._set_bridge(bridge);

        // (android) jsbridge must be `init()`ed
        bridge.init(function () {});
      }
    }, {
      key: '_setup',
      value: function _setup() {
        var _this7 = this;

        if (window.WebViewJavascriptBridge) {
          this._android_ready();
          return;
        }

        document.addEventListener('WebViewJavascriptBridgeReady', function () {
          _this7._android_ready();
        }, false);
      }

      // [JsBridge](https://github.com/lzyzsd/JsBridge) for android
      // could not handle callback data other than strings

    }, {
      key: '_proxy',
      value: function _proxy(callback) {
        return function (data) {
          if (data) {
            data = JSON.parse(data);
          }

          return callback(data);
        };
      }
    }]);
    return Bridge;
  }(BridgeBase);

  return new Bridge();
}

function uni_factory() {
  var Bridge = function (_BridgeBase3) {
    (0, _inherits3.default)(Bridge, _BridgeBase3);

    function Bridge() {
      (0, _classCallCheck3.default)(this, Bridge);
      return (0, _possibleConstructorReturn3.default)(this, (Bridge.__proto__ || (0, _getPrototypeOf2.default)(Bridge)).call(this));
    }

    (0, _createClass3.default)(Bridge, [{
      key: '_uni_ready',
      value: function _uni_ready() {
        var bridge = window.WebViewJavascriptBridge;
        this._set_bridge(bridge);
        uni.postMessage({
          data: {
            handlerName: 'bridgeLoaded'
          }
        });
        // (uni) jsbridge must be `init()`ed
        // bridge.init(() => { })
      }
    }, {
      key: '_setup',
      value: function _setup() {
        var _this9 = this;

        if (window.WebViewJavascriptBridge) {
          this._uni_ready();
          return;
        }
        // this._uni_ready()
        document.addEventListener('WebViewJavascriptBridgeReady', function () {
          _this9._uni_ready();
        }, false);
      }

      // [JsBridge](https://github.com/lzyzsd/JsBridge) for android
      // could not handle callback data other than strings

    }, {
      key: '_proxy',
      value: function _proxy(callback) {
        return function (data) {
          if (data) {
            data = JSON.parse(data);
          }
          return callback(data);
        };
      }
    }]);
    return Bridge;
  }(BridgeBase);

  return new Bridge();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/bridge/lib/base.js
// module id = 923
// module chunks = 0